
import { mapState } from 'vuex'
import messages from '~/locales/checkin.translate'
import sharedMessages from '~/locales/common.translate'
import { ROLE_CAPTAIN } from '~/utils/constants'
import { isMonthlyQualifier } from '~/utils/segmentPhase'
import { searchSegmentById, getRosterMinSizeFromSegment } from '~/utils/segment'

export default {
	i18n: {
		messages,
		sharedMessages,
	},
	computed: {
		...mapState('match', ['upcomingMatch']),
		...mapState(['scToken', 'globalCreateWarLoading']),
		...mapState('user', ['clan', 'clanMembers', 'userId']),
		...mapState('event', ['segments']),

		activeSegment() {
			return searchSegmentById(this.segments, this.upcomingMatch?.segment?.id)
		},

		rosterMinSize() {
			return getRosterMinSizeFromSegment(this.activeSegment)
		},

		isMonthlyQualifier() {
			return isMonthlyQualifier(this.activeSegment)
		},
	},

	data: () => ({
		key: 0,
		isLoading: true,
		isLoadingCheckIn: false,
		validSelectedRoster: false,
		players: [],
	}),

	watch: {
		clanMembers: {
			async handler(newValue) {
				if (!newValue?.length) {
					this.isLoading = false
					return
				}

				this.players = newValue.filter((m) => m.isRosterMember && m.userId)
				const readyMembers = this.players.filter(
					(p) => p.townHallLevel === this.clan?.thLevel
				)

				// in case of the roster has more than max size
				// only the captain should be selected
				if (readyMembers.length !== this.rosterMinSize) {
					this.players = this.players.map((i) => {
						i.isSelected = this.isCaptain(i)
						return i
					})
				} else {
					// in case of the roster has less than max size
					// all members should be selected
					this.players = this.players.map((i) => {
						i.isSelected = !!readyMembers.find((m) => m.tag === i.tag)
						return i
					})
				}

				await this.$nextTick()
				this.onCheckboxInputChanged()
				this.isLoading = false
			},
			deep: true,
			immediate: true,
		},
	},

	mounted() {
		this.$nuxt.$on('checkbox-input-changed', () => {
			this.onCheckboxInputChanged()
		})
	},

	beforeDestroy() {
		this.$nuxt.$off('checkbox-input-changed')
	},

	methods: {
		isCaptain(player) {
			return (
				player.rosterPosition === ROLE_CAPTAIN &&
				player.townHallLevel === this.clan?.thLevel
			)
		},
		async checkinForMatch() {
			try {
				this.isLoadingCheckIn = true

				let players = []
				if (this.isMonthlyQualifier) {
					players = this.players.filter((p) => p.isSelected).map((p) => p.tag)
				}

				const deeplink = await this.$checkInForMatch(this.upcomingMatch.id, players)

				if (deeplink) {
					document.location = deeplink

					await this.$logApi.createLogMessage(`Got match deeplink`, {
						matchId: this.upcomingMatch.id,
						deeplink,
					})

					setTimeout(() => {
						this.$store.commit('match/setShouldCheckin', false)
						this.$store.commit('setGlobalCreateWarLoading', false)
						this.isLoadingCheckIn = false
						window.location = 'clashofclans://OpenWar'
					}, 1000)
				} else {
					this.key++
					this.isLoadingCheckIn = false
					this.$store.commit('match/setShouldCheckin', false)
				}
			} catch (error) {
				this.isLoadingCheckIn = false
				this.$store.commit('match/setShouldCheckin', false)
			}
		},

		onCheckboxInputChanged() {
			if (!this.isMonthlyQualifier) {
				this.validSelectedRoster = true
				return
			}

			const amountPlayers = this.players.filter((p) => p.isSelected).length
			this.validSelectedRoster = amountPlayers === this.rosterMinSize
		},
	},
}
